import {WithoutSummaryModel} from "../../../../../../../common/entity/dto/plain/withoutSummary.model";
import {LovValueSummary} from "../../../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {Moment} from "moment";

export class TreatmentJourneyStepTriggerModel extends WithoutSummaryModel {
    type: LovValueSummary;
    stepDefinitionId: number;
    nbDays: number;
    date: Moment;
    estimatedDate: Moment;
}